import esESMessages from 'features/app/locales/messages/es-ES';

const esESLanguage = {
  locale: 'es-ES',
  messages: esESMessages,
};

export default esESLanguage;
